import { useState } from "react";
import './home.css'

import { Link, useNavigate } from "react-router-dom";

import { auth } from "../../fireconnection";
import { signInWithEmailAndPassword } from "firebase/auth";
import { toast } from "react-toastify";
import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth";

const provider = new GoogleAuthProvider();

export default function Home() {
    
    const auth = getAuth();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const navigate = useNavigate();

    async function handleLogin(e){
        e.preventDefault();

        if(email !== '' && password !== ''){
            await signInWithEmailAndPassword(auth, email, password)
            .then(()=>{
                navigate('./admin', {replace: true})
            }).catch(err =>{
                toast.error('Erro ao fazer o login')
            })
        }else{
            toast.warn('preencha todos os campos')

        }

    }

    
    async function handleLoginGoogle() {

        signInWithPopup(auth, provider)
        .then((result) => {

            const credential = GoogleAuthProvider.credentialFromResult(result);
            const token = credential.accessToken;
            const user = result.user;
            console.log(user)
            navigate('/admin', {replace: true})
        }).catch((error) => {
            const errorCode = error.code;
            const errorMessage = error.message;
            const email = error.customData.email;
            const credential = GoogleAuthProvider.credentialFromError(error);
            // ...
            });
        
    }

 return (
   <div className="home-container" onSubmit={handleLogin}>
    <h1>Lista de Tarefas</h1>
    <span>Gerencie suas taredas de forma fácil.</span>
    
    <form className="form">
        <input
            type="text"
            placeholder="Digite seu email"
            value={email}
            onChange={e => setEmail(e.target.value)}
        />
        <input
            type="password"
            placeholder="**********"
            value={password}
            onChange={e => setPassword(e.target.value)}
        />
        
        <button type="submit" >Acessar</button>
        <Link className="button-link" to='reset'>Esqueceu a senha?</Link>
    </form>

    <div className="line-ou">
        <hr/> ou <hr/>
    </div>

    <button className="google-container" onClick={handleLoginGoogle}>
        <img src={require('./../../assets/google-icon.png')}/>
        Entrar com o Google
    </button>

    <Link to='/register' className="button-link" >Não possui uma conta?
        <span> Cadastre-se</span>
    </Link>
   </div>
 );
}